import { get, set } from 'lodash';
import { isTrue } from 'src/utils/helper';
import Schema from 'validate';
import { isPostalCode } from 'validator';

// import schemas
import OrgaSchema from 'src/lib/paths/organisation_FULL_Paths.json';
const P = OrgaSchema.attributes;

const postalCodeValidator = (val: string) => {
	try {
		if (val === '') return true;
		return isPostalCode(val, 'DE');
	} catch (error) {
		return false;
	}
};

function AbteilungsDatenValidator(formValues: any) {
	const schema = createSchema(formValues);
	const DynamicAbteilungsDatenValidator = new Schema(schema, { strip: false });
	DynamicAbteilungsDatenValidator.message({
		required: (_path: string) => 'Dies ist ein Pflichtfeld',
		type: (path: string) => `Das Formular ist fehlerhaft, bitte melden Sie diesen Felder. Geben Sie als Grund "falscher Datentyp, ${path}" an`,
	});
	return DynamicAbteilungsDatenValidator;
}

function createSchema(formValues: any) {
	const schema = {
		[P.Hochschule.path]: {
			required: true,
		},
		[P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path]: {
			type: String,
			required: true,
		},
		[P.Adressdaten_Strasse_Und_Hausnummer.path]: {
			type: String,
			required: true,
		},
		[P.Adressdaten_Adresszusatz.path]: {
			type: String,
		},
		[P.Adressdaten_PLZ.path]: {
			type: String,
			required: true,
			use: { postalCodeValidator },
			message: {
				postalCodeValidator: 'Ungültige Postleitzahl.',
			},
		},
		[P.Adressdaten_Ort.path]: {
			type: String,
			required: true,
		},
		[P.Adressdaten_Abweichender_Sitz.path]: {
			type: Boolean,
		},
	};

	const abweichenderSitzValue = get(formValues, P.Adressdaten_Abweichender_Sitz.path);

	if (isTrue(abweichenderSitzValue)) {
		set(schema, P.Adressdaten_Abweichender_Sitz_Adresse_Strasse_Und_Hausnummer.path, { type: String, required: true });
		set(schema, P.Adressdaten_Abweichender_Sitz_Adresse_PLZ.path, {
			type: String,
			required: true,
			use: { postalCodeValidator },
			message: { postalCodeValidator: 'Ungültige Postleitzahl.' },
		});
		set(schema, P.Adressdaten_Abweichender_Sitz_Adresse_Ort.path, { type: String, required: true });
	}

	return schema;
}

export default AbteilungsDatenValidator;
